/*****************************************************************************
 *
 * Constant definitions of the cost, display, summaries, and variable types
 * used throughout the application
 *
 *****************************************************************************/

export const USER_GUIDE_PUBLIC_FILE = "Opioid-Dashboard-user_guide_states_only.pdf"

export const COSTS = {
  TOTAL: "TOTAL",
  FATAL: "FATAL",
  NONFATAL: "NONFATAL"
}

export const DISPLAYS = {
  CHART: "CHART",
  TABLE: "TABLE"
}

export const SUMMARIES = {
  SUMMARY: "SUMMARY",
  DETAIL: "DETAIL"
}

export const VARIABLES = {
  Location: 'Location',
  State: 'State',
  StateID: 'StateID',
  County: 'County',
  CountyID: 'CountyID',
  OUD_Total: 'OUD_Total',
  OUDC_HealthCare: 'OUDC_HealthCare',
  OUDC_Treatment: 'OUDC_Treatment',
  OUDC_CriminalJustice: 'OUDC_CriminalJustice',
  OUDC_LostProductivity: 'OUDC_LostProductivity',
  OUDC_RQL: 'OUDC_RQL',
  OUDC_Total: 'OUDC_Total',
  OUDC_TotalPercent: 'OUDC_TotalPercent',
  OUDC_Total_quartile: 'OUDC_Total_quartile',
  OUDC_perCapita: 'OUDC_perCapita',
  OUDC_perCapita_quartile: 'OUDC_perCapita_quartile',
  FOD_Total: 'FOD_Total',
  FODC_HealthCare: 'FODC_HealthCare',
  FODC_LostProductivity: 'FODC_LostProductivity',
  FODC_VSL: 'FODC_VSL',
  FODC_Total: 'FODC_Total',
  FODC_TotalPercent: 'FODC_TotalPercent',
  FODC_Total_quartile: 'FODC_Total_quartile',
  FODC_perCapita: 'FODC_perCapita',
  FODC_perCapita_quartile: 'FODC_perCapita_quartile',
  TotalCost: 'TotalCost',
  TotalCost_quartile: 'TotalCost_quartile',
  Cost_perCapita: 'Cost_perCapita',
  Cost_perCapita_quartile: 'Cost_perCapita_quartile',
  POP: 'POP'
};

export const QUARTILE_COLORS = {
  1: "#fef0da",
  2: "#fdcc89",
  3: "#fc8d59",
  4: "#d7311f"
}
